export default {"src":"/_next/static/media/pic_03.5b233203.JPG","height":4000,"width":6000,"blurWidth":0,"blurHeight":0};